export default __webpack_public_path__ + "static/media/delete_red.4a50192a.svg";